import { TourProps } from '../types';

export const COMMONS = {
  BACK_BUTTON: () => ({
    id: 'back-button',
    content: 'You can always go back to the main audit list from here.',
  }),
  CURRENCY_REFERENCE: () => ({
    id: 'currency-reference',
    content: 'Switch between global and local currencies to view amounts in your preferred currency.',
  }),
  DATE_REFERENCE: () => ({
    id: 'date-reference',
    content: 'Select a date reference to organize and sort the data accordingly.',
  }),
  METRICS: () => ({
    id: 'metrics',
    content: 'Get a quick overview of total amounts, deviations, and flagged items.',
  }),
  REFRESH: () => ({
    id: 'refresh',
    content: 'Refresh the data to make sure you are looking at the latest information.',
  }),
};
